import { render, staticRenderFns } from "./FormatReferenceTagFilter.vue?vue&type=template&id=260e399a&scoped=true&"
import script from "./FormatReferenceTagFilter.vue?vue&type=script&lang=ts&"
export * from "./FormatReferenceTagFilter.vue?vue&type=script&lang=ts&"
import style0 from "./FormatReferenceTagFilter.vue?vue&type=style&index=0&id=260e399a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260e399a",
  null
  
)

export default component.exports